<div
  class="rounded-lg border border-zinc-100 shadow-md focus-within:border-zinc-400 hover:border-zinc-300 focus:border-zinc-400 has-[:focus-visible]:border-zinc-400">
  @if (suggestionsAvailable()) {
    <h3 class="text-sm">{{ 'chatMessages.intentSuggestion.hint' | transloco }}</h3>

    <div class="mb-4 mt-4 flex flex-wrap gap-2" data-testid="chat-input-suggestions">
      @for (suggestion of suggestions(); track suggestion) {
        <button (click)="postSuggestion(suggestion)" class="inline-block">
          <p-chip class="border border-zinc-200 !bg-white">
            {{ suggestion }}
            <i class="pi pi-angle-right"></i>
          </p-chip>
        </button>
      }
    </div>
  }

  <!-- Close suggestions -->
  @if (suggestionsAvailable()) {
    <p-button
      severity="secondary"
      [rounded]="true"
      icon="pi pi-times-circle"
      size="small"
      class="absolute right-2 top-2"
      [attr.aria-label]="'global.close' | transloco"
      (onClick)="closeSuggestions()" />
  }

  <ng-content></ng-content>
</div>
